import axios from 'axios'

const state = {
  cached: [],
  pageNr: 1,
  statusUpdates: [],
}

const getters = {
  getPageNr(state) {
    return state.pageNr
  },
  getStatusUpdates(state) {
    return state.statusUpdates
  },
}

const mutations = {
  SET_PAGENR(state, newValue) {
    state.pageNr = newValue
  },
  CACHE_USER(state, newUser) {
    state.cached.push(newUser)
  },
  SET_STATUS_UPDATES(state, newValue) {
    if (state.pageNr === 1) {
      state.statusUpdates = newValue
    } else {
      state.statusUpdates = state.statusUpdates.concat(newValue)
    }
  },
  UPDATE_STATUS_UPDATE(state, newValue) {
    state.statusUpdates.forEach((element, index) => {
      if (element.id === newValue.id) {
        state.statusUpdates[index] = newValue
      }
    })
  },
}

const actions = {
  fetchUser({ commit, state, rootState }, { userId }) {
    // 1. Check if we already have the user as a current user.
    const { currentUser } = rootState.auth
    if (currentUser && currentUser.id === userId) {
      return Promise.resolve(currentUser)
    }

    // 2. Check if we've already fetched and cached the user.
    const matchedUser = state.cached.find((user) => user.id === userId)
    if (matchedUser) {
      return Promise.resolve(matchedUser)
    }

    // 3. Fetch the user from the API and cache it in case
    //    we need it again in the future.
    return axios.get(`/api/v1/user/${userId}`).then((response) => {
      const user = response.data
      commit('CACHE_USER', user)
      return user
    })
  },
  fetchStatusUpdates({ commit, dispatch, getters }, { userId, pageNr }) {
    if (pageNr) commit('SET_PAGENR', pageNr)
    return axios
      .get(
        `/api/v1/user/${userId}/status_updates/${getters.getPageNr}/type/all`
      )
      .then((response) => {
        commit('SET_STATUS_UPDATES', response.data)
        commit('SET_PAGENR', getters.getPageNr + 1)
        return response.data
      })
  },
  postNewComment(
    { commit, dispatch, getters },
    { content, statusUpdateId, userId }
  ) {
    return axios
      .post(`/api/v1/comment`, {
        content: content,
        status: 'approved',
        status_update_id: statusUpdateId,
        user_id: userId,
      })
      .then((response) => {
        return response.data
      })
  },
  likeComment({ commit, dispatch, getters }, { commentId }) {
    return axios
      .post(`/api/v1/comments/add_like`, {
        commentId: commentId,
      })
      .then((response) => {
        return response.data
      })
  },
  likePost({ commit, dispatch, getters }, { statusUpdateId }) {
    return axios
      .post(`/api/v1/status_updates/add_like`, {
        statusUpdateId: statusUpdateId,
      })
      .then((response) => {
        return response.data
      })
  },
  changeStatus({ commit, dispatch, getters }, { statusUpdateId, status }) {
    return axios
      .post(`/api/v1/status_update/change_status`, {
        status: status,
        status_update_id: statusUpdateId,
      })
      .then((response) => {
        commit('UPDATE_STATUS_UPDATE', response.data)
        return response.data
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
